import React, { useEffect, useState, useRef, useMemo } from "react";
import apiCall from "../Api/api";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import path from "../../assets/img/locationpath.svg";
import print from "../../assets/img/printP.png";
import rupees from "../../assets/img/rupees.png";
import { useParksContext } from "../../provider/ParksProvider";
import { useMasterContext } from "../../provider/MasterProvider";
import { useSearchParams } from "react-router-dom";
import rupeeFormat from "../Api/RupeeFormat";
import ParkCardSekelton from "../common/Skeleton/park/ParkCardSekelton";
import ParkSelectedFilters from "./ParkSelectedFilters";
import parse from 'html-react-parser';
import { common } from "Data/common";

const PARKDATA = common?.ALL_PARKS?.PARKS;


const Parks = () => {
  const { parksData, pageIndex, summary, filters, parksDispatch } =
    useParksContext();
  const { masterLoading, parksSortBy } = useMasterContext();
  const [, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const isFetchingRef = useRef(false);

  useEffect(() => {
    const fetchParks = async () => {
      if (isFetchingRef.current) return;
      isFetchingRef.current = true;
      setLoading(true);
      try {
        const queryParams = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((v) => queryParams.append(`${key}[]`, v));
          } else if (value !== 0 && value !== null && value !== "") {
            queryParams.append(key, value);
          }
        });

        if (summary?.pageSize) queryParams.append("pageSize", summary.pageSize);
        if (pageIndex) queryParams.append("page", pageIndex);

        const response = await apiCall({
          url: `park?${queryParams.toString()}`,
          method: "GET",
        });

        const parkData = response?.data?.parks?.data || [];
        const parkSummary = response?.data?.parks?.summary;

        if (pageIndex === 1) {
          parksDispatch({ type: "SET_PARKS_DATA", payload: parkData });
        } else {
          parksDispatch({ type: "APPEND_PARKS_DATA", payload: parkData });
        }

        parksDispatch({
          type: "PARKS_SUMMARY",
          payload: {
            total: parkSummary.total,
            page: parkSummary.page,
            pageSize: parkSummary.pageSize,
            total_page: parkSummary.total_page,
          },
        });
      } catch (err) {
        console.error("Error fetching parks:", err);
      } finally {
        setLoading(false);
        isFetchingRef.current = false;
      }
    };

    fetchParks();
  }, [summary?.pageSize, filters, pageIndex]);





  const handleSortChange = (e) => {
    parksDispatch({ type: "SET_PAGE_INDEX", payload: 1 });
    const value = Number(e.target.value);
    updateFilter("custom_sort_by", value);
  };
  const updateFilter = (name, value) => {
    parksDispatch({
      type: "UPDATE_PARKS_FILTER",
      payload: { [name]: value },
    });
  };

  useEffect(() => {
    const newParams = new URLSearchParams();

    // Add filters to URL params
    Object.entries(filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        value.forEach((v) => newParams.append(`${key}[]`, v));
      } else if (value !== 0 && value !== null && value !== "") {
        newParams.set(key, value);
      }
    });

    // Add page
    newParams.set("page", pageIndex);

    setSearchParams(newParams);
  }, [pageIndex, filters, parksSortBy]);

  const processedParks = useMemo(() => {
    return parksData?.map((park) => ({
      ...park,
    }));
  }, [parksData, pageIndex]);




  return (
    <>

      <div className="topfilter d-lg-flex d-none justify-content-between align-items-center w-100 mb-2">
        <div className="left_text">
          <p className="mb-0">
            {PARKDATA?.PARK_TEXT_1}{" "}
            <strong className="parklistcount">
              {summary?.total} {PARKDATA?.PARK_TEXT_2}
            </strong>{" "}
            {PARKDATA?.PARK_TEXT_3}
          </p>
        </div>
        <div className="right-select mb-md-0 mb-4">
          <div className="input_check pb-0">
            <form id="custom_sort_by_form">
              <select
                id="sharesafarisearch-custom_sort_by"
                name="custom_sort_by"
                aria-label="Default select example"
                className="form-select mb-2 custom_sort_by_input"
                value={filters?.custom_sort_by}
                onChange={handleSortChange}
              >
                {Array.isArray(parksSortBy) && parksSortBy?.length > 0 ? (
                  parksSortBy?.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))
                ) : masterLoading ? (
                  <option key={"1"} value={""}>
                    {"Sort by : Most Demanding"}
                  </option>
                ) : (
                  <p>{PARKDATA?.NO_FILTER}</p>
                )}
              </select>
            </form>
          </div>
        </div>
      </div>

      <ParkSelectedFilters />
      {Array.isArray(processedParks) && processedParks?.length > 0 ? (
        processedParks?.map((park, index) => (
          <Link
            key={index}
            to={`/park/${park.slug}`}
            className="parking_Box"
            data-pjax="0"
          >
            <div className="searchSafari_wraper mb-4">
              <Row>
                <Col md={3} xs={12}>
                  <div className="Slider_safariimg3 h-100 w-100">
                    <img
                      src={park.feature_image_path}
                      alt={park.title || "Park image"}
                      className="w-100 h-100"
                    />
                  </div>
                </Col>
                <Col md={9} xs={12}>
                  <div className="safariSearch_wrap">
                    <div className="safrititles tite_parklist pt-sm-0 pt-3">
                      <h4>{park.title} </h4>
                    </div>
                    <div className="detailesOrLocation d-flex justify-content-between flex-wrap">
                      <div className="items_bg d-flex gap-1">
                        <div className="top_list">
                          <img src={path} alt="" />
                        </div>
                        <div>
                          <div className="d-flex flex-column">
                            <span className="mark_area">{PARKDATA?.LOCATION}</span>
                            <span className="titles_filed">
                              {`${park.state?.state_name}, ${park.location?.title}`}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="items_bg d-flex gap-1">
                        <div className="top_list">
                          <img src={print} alt="" style={{ height: "16px" }} />
                        </div>
                        <div className="d-flex flex-column">
                          <span className="mark_area">{PARKDATA?.WILD_LIFE}</span>
                          <span className="titles_filed">
                            {park?.animal_text
                              ?.split(" ")
                              .slice(0, 6)
                              .join(" ") + (park?.animal_text?.split(" ").length > 6 ? "..." : "")}

                          </span>
                        </div>
                      </div>
                      <div className="items_bg d-flex gap-1">
                        <div className="top_list">
                          <img src={rupees} alt="" style={{ height: "16px" }} />
                        </div>
                        <div className="d-flex flex-column">
                          <span className="mark_area">{PARKDATA?.COST}</span>
                          <span className="titles_filed">
                            {/* {`${park.avg_safari_price_min} - ${park.avg_safari_price_max}`} */}
                            {`${rupeeFormat(
                              park.avg_safari_price_min
                            )} - ${rupeeFormat(park.avg_safari_price_max)}`}
                            <span className="avg_price">{PARKDATA?.PRICE}</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="seelctes_text pt-2 pb-4">
                      <p>{park?.short_description && parse(park?.short_description)}</p>
                    </div>
                    <div className="tour_logosliders">
                      {/* <div className="taglines">
                          <p>Top Safari Tour Operators</p>
                        </div> */}
                      <div className="touroprators text-center">
                        {/* <Swiper
                            modules={[Navigation, Pagination, Autoplay]}
                            spaceBetween={10}
                            slidesPerView={5}
                            autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                            }}
                            loop={true}
                            className="opratios-slider"
                          >
                            {(park.top_operators || []).map((operator, i) => (
                              <SwiperSlide key={`${park.id || index}-${i}`}>
                                <div className="slidesImg">
                                  <img
                                    src={operator.image_path}
                                    alt={operator.name || `Operator ${i + 1}`}
                                    className="w-100"
                                  />
                                </div>
                              </SwiperSlide>
                            ))}
                          </Swiper> */}
                        <div className="more_btn">{PARKDATA?.KNOW_MORE_BUTTON}</div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Link>
        ))
      ) : loading ? (
        <ParkCardSekelton />
      ) : (
        <p>{PARKDATA?.NO_DATA}</p>
      )}
      <div className="d-flex justify-content-center my-4">
        {loading ? (
          <div
            className="spinner-border loading-spinner"
            role="status"
          >
            <span className="visually-hidden">{PARKDATA?.LOAD_MORE}</span>
          </div>
        ) : (
          summary?.page < summary?.total_page && (
            <>
            {/* <button
              className="join_btn newbgjoin mt-sm-0 mt-2"
              onClick={() => {

                const nextPage = pageIndex + 1
                parksDispatch({
                  type: "SET_PAGE_INDEX",
                  payload: nextPage,
                });
              }}
            >
              Show More Park
            </button> */}
            </>
          )
        )}
      </div>

    </>
  );
};

export default Parks;
